export enum HolterLeadCount {
    fiveLeads = 'fiveLeads',
    threeLeads = 'threeLeads',
}
